import { Box, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import { Tab, TabPanel, Tabs, TabsList } from '@/components/common/Tab';
import ManagePartners from '@/components/dashboard_components/manage_partner_dashboard/ManagePartners';
import ManageUsers from '@/components/dashboard_components/manage_user_dashboard/ManageUsers';
import ReviewerAssignments from '@/components/dashboard_components/manage_user_dashboard/reviewers/ReviewerAssignments';
import Header from '@/components/header/Header';
import { UsersContext } from '@/Contexts/UsersContext';
import useReviewInformation from '@/hooks/useReviewInformation';
import { ReviewerAssignmentProps } from '@/models/ReviewerAssignment';
import { UserType } from '@/models/User';

export default function UserManagement() {
  const { getReviewerAssignments } = useReviewInformation();

  const { userType, userCurrent } = useContext(UsersContext);
  const [currentReviewerStateIds, setCurrentReviewerStateIds] = useState<string[]>([]);

  const [reviewerAssignments, setReviewerAssignments] = useState<ReviewerAssignmentProps[] | null>(
    null
  );

  const [reviewerAssignmentLookup, setReviewerAssignmentLookup] = useState<{
    [key: string]: ReviewerAssignmentProps[];
  }>();

  useEffect(() => {
    if (userCurrent?.email && reviewerAssignmentLookup) {
      const currentRev = reviewerAssignmentLookup[userCurrent.email];
      if (currentRev) {
        let revStates = currentRev.map((x: ReviewerAssignmentProps) => x.stateId);

        // get unique values
        revStates = [...new Set(revStates)];

        setCurrentReviewerStateIds(revStates);
      }
    }
  }, [reviewerAssignmentLookup, userCurrent?.email]);

  useEffect(() => {
    if (!reviewerAssignments) {
      switch (userType) {
        case UserType.Adf:
          getReviewerAssignments().then((reviewers: ReviewerAssignmentProps[]) => {
            setReviewerAssignments(reviewers);
          });
          break;
        case UserType.StateCoordinator:
          if (userCurrent?.contact?.stateId) {
            getReviewerAssignments(userCurrent.contact.stateId).then(
              (reviewers: ReviewerAssignmentProps[]) => {
                setReviewerAssignments(reviewers);
              }
            );
          }
          break;
      }
    }
  }, [getReviewerAssignments, reviewerAssignments, userCurrent, userType]);

  useEffect(() => {
    if (!reviewerAssignmentLookup && reviewerAssignments) {
      const assignLookup: { [key: string]: ReviewerAssignmentProps[] } = {};

      reviewerAssignments.forEach(function (reviewerAssignment: ReviewerAssignmentProps) {
        if (!reviewerAssignment.email) return;
        const userEmail = reviewerAssignment.email.trim().toLowerCase();

        if (Object.keys(assignLookup).includes(userEmail)) {
          assignLookup[userEmail].push(reviewerAssignment);
        } else {
          assignLookup[userEmail] = [reviewerAssignment];
        }
      });

      setReviewerAssignmentLookup(assignLookup);
    }
  }, [reviewerAssignments, reviewerAssignmentLookup]);

  return (
    <Box display='flex' flexDirection='column'>
      <Header />
      <Box
        display='flex'
        minHeight='110px'
        flexDirection='row'
        alignItems='center'
        justifyContent='space-between'
      >
        <Box flex={1} textAlign='center'>
          <Typography variant='h1'>User Management Dashboard</Typography>
        </Box>
      </Box>

      <Box
        display='flex'
        flexDirection='column'
        width='100%'
        height='calc(100% - 40px)'
        marginTop='8px'
        marginBottom='8px'
        flex='1 1 auto'
      >
        <Tabs
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
          }}
          defaultValue={userType == UserType.StateCoordinator ? 1 : 0}
        >
          <TabsList
            sx={{
              marginLeft: '10px',
              marginRight: '10px',
              marginBottom: '12px',
            }}
          >
            <Tab label='Item Two'>MANAGE USER ACCOUNTS</Tab>
            {userType != UserType.Applicant ? (
              <Tab label='Item Three'>MANAGE REVIEWER ASSIGNMENTS</Tab>
            ) : (
              <></>
            )}
            {userType == UserType.Adf ? <Tab label='Item Four'>MANAGE PARTNERS</Tab> : <></>}
          </TabsList>
          <TabPanel value={0}>
            <ManageUsers currentReviewerStateIds={currentReviewerStateIds} />
          </TabPanel>
          {userType != UserType.Applicant && userType != UserType.NationalProgrammeLead ? (
            <TabPanel value={1}>
              <ReviewerAssignments
                currentReviewerStateIds={currentReviewerStateIds}
                reviewerAssignmentLookup={reviewerAssignmentLookup ?? {}}
              />
            </TabPanel>
          ) : (
            <></>
          )}
          {userType == UserType.Adf ? (
            <TabPanel value={2}>
              <ManagePartners />
            </TabPanel>
          ) : (
            <></>
          )}
        </Tabs>
      </Box>
    </Box>
  );
}
